module.exports = __webpack_public_path__ + "static/thumb-rocket-f69498de12044863ae254faacacac862.jpg";